export { Text } from "./text";
